import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";

import './personalSettings.scss';
import {
    Donation,
    Exit,
    Info,
    Magnificer,
    Mails,
    Message,
    User,
    UserPlus,
    Users,
    Verified,
    Wallet
} from "../../../uiKit/assets/svg/icons";
import Title from "../../../uiKit/Title/Title";
import MenuItem from "../CommunityMenu/MenuItem";

import { logout } from "../../../redux/state/accountSlice";
import { getPaymentSettings, getSavedCard } from "../../../redux/state/paymentSlice";

export const settings = [
    { Icon: Users, title: 'My Communities', url: '/my-com' },
    { Icon: UserPlus, title: 'Create New Community', url: '/new-community' },
    { Icon: User, title: 'Personal Info', url: '/personal-info' },
    { Icon: Mails, title: 'Notifications', url: '/notifications' },
    { Icon: Wallet, title: 'Payment Preferences', url: '/payment-preferences' },
    { Icon: Donation, title: 'My Donations', url: '/my-donations' },
    { Icon: Verified, title: 'Login & Security', url: '/login-security' },
    { Icon: Message, title: 'Contact Us', url: '/contact-us' },
    { Icon: Info, title: 'Tutorials', url: '/tutorials' },
    { Icon: Magnificer, title: 'FAQ', url: '/faq' },
]

const PersonalSettings = () => {

    const dispatch = useDispatch();
    const history = useHistory();

    useEffect(() => {
        dispatch(getPaymentSettings())
        dispatch(getSavedCard());
    }, [dispatch])

    return (
        <div className='settingsWrapper'>
            {settings.map((item, index) => (
                <MenuItem Icon={item.Icon} title={item.title} key={index} url={item.url} />
            ))}
            <div
                className='menuItem'
                onClick={() => {
                    dispatch(logout());
                    history.push('/');
                }
                }
            >
                <div style={{ display: 'flex' }}>
                    <div className='menuIcon'>
                        <Exit />
                    </div>
                    <Title
                        text='Log out'
                        fontWeight={400}
                        style={{ paddingLeft: '16px' }}
                    />
                </div>
            </div>
        </div>
    )
}

export default PersonalSettings;